// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"e720885a","98":"a63a1bce","411":"5ce88009","463":"bcb47bf0","532":"6ca9574d"}[chunkId] + ".chunk.js";
};